/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import "jspdf-autotable";
import TableHeader from "../../Common/TableHeader";
import Loader from "../../Common/Loader";
import Pagination from "../../Common/Pagination";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import ajaxBank from "../../../util/remote/ajaxBank";
import TermlyFeesFilterForm from "../../Common/Statistics/TermlyFeesFilterForm";

function TermlyFeesList() {

    const [termlyFees, setTermlyFees] = useState(false);
    const [termlyFeeSearchTerm, setTermlyFeeSearchTerm] = useState("");
    const [termlyFeeStartDate, setTermlyFeeStartDate] = useState("");
    const [termlyFeeEndDate, setTermlyFeeEndDate] = useState("");
    const [termlyFeeTerm, setTermlyFeeTerm] = useState("");
    const [termlyFeeSchool, setTermlyFeeSchool] = useState("");

    const [termlyFeePage,setTermlyFeePage] = useState(1)
    const [termlyFeeMeta,setTermlyFeeMeta] = useState([])
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [modal, setModal] = useStateCallback(false);

    useEffect(() => {
        if (termlyFeeSearchTerm || termlyFeeStartDate || termlyFeeEndDate || termlyFeeTerm || termlyFeeSchool) {
          searchTermlyFees();
        } else {
          getTermlyFees(termlyFeePage);
        }
      }, [termlyFeePage]);
  
    const getTermlyFees = async (currentPage) => {
        setLoading(true);
        const server_response = await ajaxBank.fetchTermlyFeeInvoices(currentPage);
        setLoading(false);
        if (server_response.status === "OK") {
          setTermlyFeeMeta(server_response.details.meta.totalPages);
          setTermlyFees(server_response.details.data || []);
        } else {
          setTermlyFees([]);
        }
    };
  
    const searchTermlyFees = async (e) => {
        if (e) {
          e.preventDefault();
        }
        setLoading2(true);
        const server_response = await ajaxBank.searchTermlyFeeInvoices(termlyFeePage, termlyFeeSearchTerm, termlyFeeStartDate, termlyFeeEndDate, termlyFeeTerm, termlyFeeSchool);
        setLoading2(false);
        if (server_response.status === "OK") {
          setTermlyFeeMeta(server_response.details.meta.totalPages);
          setTermlyFees(server_response.details.data || []);
        } else {
          setTermlyFees([]);
        }
        
    };
  

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= termlyFeeMeta) {
      setTermlyFeePage(newPage);
    }
  };

  const handleFilter = () => {
    setModal(false, () => setModal(<TermlyFeesFilterForm g={setTermlyFees} h={setTermlyFeeMeta} page={termlyFeePage} isOpen={true}/>));
  };

  const setFees= (e) => {
    e.preventDefault();
    setTermlyFeeSearchTerm("");
    setTermlyFeeStartDate("");
    setTermlyFeeEndDate("");
    setTermlyFeeSchool("")
    setTermlyFeeTerm("");
    setTermlyFeePage(1);
    getTermlyFees(1);
    
  };


  return (
    <div className="col-lg-12 col-md-12 mt-3">
      {modal}
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Termly Fee Invoice List"
          subtitle="List of all the termly fee invoices sorted by the most recent"    
        />
        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
          <div class="dropdown-menu dropdown-menu-right">
            <Link class="dropdown-item" onClick={setFees}> <i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
            <Link class="dropdown-item" onClick={handleFilter}> <i class="fas fa-filter"></i>Filter</Link>

          </div>
        </div>
      </div>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">Invoice Date</th>
                <th scope="col">Student Name</th>
                <th scope="col">Status</th>
                <th scope="col"> Amount Invoiced</th>

                </tr>
            </thead>
            <tbody>
                {termlyFees.length > 0 ? (
                    termlyFees.map((item, index) => (
                    <tr key={index}>
                        

                        <td>
                        {item.created_at?.short_date}
                        <br />
                      <small>
                      {item.created_at?.time}
                      </small>
                        </td>
                        
                        <td>
                            {item.student}<br/>
                            <small>{item.school}</small>
                        </td>
                       
                        <td>{item.invoice_status === "PAID"?
                          <i className="fa fa-circle-check text-teal fs-9px fa-fw me-5px"style={{ color: "#28a745" }}></i>
                          :<i className="fa fa-hourglass-half text-teal fs-9px fa-fw me-5px" style={{ color: "#ffc107" }} ></i>
                        }
                        
                        </td>
                        <td><span className="badge bg-teal">
                        <i className="fa fa-circle text-teal fs-9px fa-fw me-5px" style={{ color: "#042954" }}></i>
                        UGX. {item.amount}
                      </span></td>
                        
                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                            No termly fee invoices yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={termlyFeePage} totalPages={termlyFeeMeta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
  );
}

export default TermlyFeesList;
